<template>
  <div :class="{ container: !isMobile }" id="app">
    <div class="card-form">
      <div class="card-form__inner">
        <!-- Loading Skeleton -->
        <template v-if="!camp">
          <div class="w-full">
            <!-- Image Skeleton -->
            <div
              class="w-full h-[200px] bg-gray-200 animate-pulse rounded-lg"
            ></div>

            <!-- Title Skeleton -->
            <div class="mt-6 space-y-4">
              <div
                class="h-8 bg-gray-200 rounded animate-pulse w-1/2 mx-auto"
              ></div>

              <!-- Form Fields Skeleton -->
              <div class="space-y-4 mt-4">
                <div class="h-4 bg-gray-200 rounded animate-pulse w-1/4"></div>
                <div
                  class="h-10 bg-gray-200 rounded animate-pulse w-full"
                ></div>
                <div class="h-4 bg-gray-200 rounded animate-pulse w-1/4"></div>
                <div
                  class="h-10 bg-gray-200 rounded animate-pulse w-full"
                ></div>
              </div>

              <!-- T-shirt Size Skeleton -->
              <div class="mt-6">
                <div class="h-4 bg-gray-200 rounded animate-pulse w-1/4"></div>
                <div
                  class="h-10 bg-gray-200 rounded animate-pulse w-full mt-2"
                ></div>
              </div>

              <!-- Add Ons Skeleton -->
              <div class="mt-6">
                <div class="h-4 bg-gray-200 rounded animate-pulse w-1/3"></div>
                <div class="space-y-2 mt-2">
                  <div
                    class="h-8 bg-gray-200 rounded animate-pulse w-full"
                  ></div>
                  <div
                    class="h-8 bg-gray-200 rounded animate-pulse w-full"
                  ></div>
                </div>
              </div>

              <!-- Emergency Contact Skeleton -->
              <div class="mt-6">
                <div class="h-8 bg-gray-200 rounded animate-pulse w-3/4"></div>
                <div class="space-y-4 mt-4">
                  <div
                    class="h-4 bg-gray-200 rounded animate-pulse w-1/4"
                  ></div>
                  <div
                    class="h-10 bg-gray-200 rounded animate-pulse w-full"
                  ></div>
                  <div
                    class="h-4 bg-gray-200 rounded animate-pulse w-1/4"
                  ></div>
                  <div
                    class="h-10 bg-gray-200 rounded animate-pulse w-full"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Actual Content -->
        <template v-else>
          <img :src="getImage()" class="card-img-top rounded-corners" />
          <h3 class="text-center" style="margin-top: 20px">Registrant Info</h3>
          <div class="row">
            <div class="card-input col">
              <label for="cardName" class="card-input__label">First Name</label>
              <input
                type="text"
                id="cardName"
                class="card-input__input"
                v-model="campers[0].firstName"
                data-ref="cardName"
                autocomplete="given-name"
                required
              />
            </div>

            <div class="card-input col">
              <label for="cardName" class="card-input__label">Last Name</label>
              <input
                type="text"
                id="cardName"
                class="card-input__input"
                v-model="campers[0].lastName"
                data-ref="cardName"
                autocomplete="family-name"
              />
            </div>
          </div>
          <li
            style="list-style-type: none"
            v-for="(count, index) in campers[0].customFields"
            :key="index"
          >
            <CustomField
              :presetField="campers[0].customFields[index]"
              :number="0"
              :index="index"
              @changed="updateFieldValue(0, index, $event.field)"
            ></CustomField>
          </li>
          <!--End of Custom Forms-->
          <div v-if="this.camp.tShirtsProvided">
            <label>T-shirt size</label>
            <select
              class="card-input__input -select"
              style="margin-bottom: 20px"
              v-model="campers[0].tShirtSize"
              required
            >
              <option disabled selected value="">Size</option>
              <option value="YS" class="option">Youth Small</option>
              <option value="YM" class="option">Youth Medium</option>
              <option value="YL" class="option">Youth Large</option>
              <option value="AS" class="option">Adult Small</option>
              <option value="AM" class="option">Adult Medium</option>
              <option value="AL" class="option">Adult Large</option>
              <option value="AXL" class="option">Adult XLarge</option>
              <option value="AXXL" class="option">Adult XXLarge</option>
            </select>
          </div>
          <div class="p-3 border-b border-gray-100" v-if="!this.hideRecruitAds">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <input
                  class="form-check-input h-4 w-4 rounded border-gray-300 focus:ring-2 focus:ring-indigo-500/50 transition-all duration-200 cursor-pointer"
                  type="checkbox"
                  v-model="campers[0].recruitPurchased"
                  id="recruitPurchased-main"
                />
                <span
                  class="text-gray-700 ml-3 font-normal cursor-pointer flex items-center"
                  @click="
                    campers[0].recruitPurchased = !campers[0].recruitPurchased
                  "
                  >Athlete Profile
                  <button
                    class="ml-8 text-gray-400 hover:text-gray-600"
                    style="margin-left: 7px"
                    @click.stop.prevent="showAthleteProfileModal = true"
                  >
                    <i class="fas fa-info-circle"></i></button
                ></span>
              </div>
              <span
                class="text-gray-800 font-normal"
                style="color: v-bind('primaryColor')"
                >$15.00<span class="text-sm text-gray-500 font-normal"
                  >/month</span
                ></span
              >
            </div>
          </div>
          <div
            v-if="campers[0].customAddOns.length > 0"
            class="bg-white rounded-md shadow-sm p-4 my-4"
          >
            <h5 class="text-center font-semibold text-lg mb-4 text-gray-700">
              Additional Items
            </h5>

            <div class="space-y-2">
              <div
                v-for="(addon, index) in campers[0].customAddOns"
                :key="index"
                class="bg-gray-50 rounded-md p-3 transition-all duration-200 hover:shadow-sm"
              >
                <div class="flex items-start gap-3">
                  <div class="pt-0.5">
                    <input
                      type="checkbox"
                      v-model="campers[0].customAddOns[index].isPurchased"
                      class="h-4 w-4 rounded border-gray-300 focus:ring-1 cursor-pointer"
                      :style="{
                        'accent-color': primaryColor,
                        '--tw-ring-color': primaryColor + '80',
                      }"
                    />
                  </div>

                  <div class="flex-grow">
                    <h5 class="font-medium text-gray-800 text-sm">
                      {{ addon.addOnName }}
                    </h5>
                    <p class="text-gray-400 text-xs mt-0.5">
                      Add this to complete your registration
                    </p>
                  </div>

                  <div
                    class="text-lg font-medium"
                    :style="{ color: '#000000' }"
                  >
                    ${{ addon.addOnPrice }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4 text-center text-xs text-gray-400">
              Select optional items to enhance your camp experience
            </div>
          </div>

          <!--start of extra registrants-->
          <div v-if="this.campers.length > 1">
            <li
              class="list-group-item m-3 v-step-5"
              v-for="(camper, camperIndex) in campers.slice(1, 4)"
              :key="'campDate' + camperIndex"
            >
              <div
                class="row"
                style="
                  border: 3px solid #45487a;
                  border-radius: 15px;
                  max-width: 558px;
                "
              >
                <h3 class="text-center" style="margin-top: 20px">
                  Registrant {{ camperIndex + 2 }} Info
                </h3>
                <div class="card-input col">
                  <label for="cardName" class="card-input__label"
                    >First Name</label
                  >
                  <input
                    type="text"
                    id="cardName"
                    class="card-input__input"
                    v-model="campers[camperIndex + 1].firstName"
                    data-ref="cardName"
                    autocomplete="given-name"
                    required
                  />
                </div>
                <div class="card-input col">
                  <label for="cardName" class="card-input__label"
                    >Last Name</label
                  >
                  <input
                    type="text"
                    id="cardName"
                    class="card-input__input"
                    v-model="campers[camperIndex + 1].lastName"
                    data-ref="cardName"
                    autocomplete="family-name"
                  />
                </div>
                <div v-if="this.camp.tShirtsProvided">
                  <label>T-shirt size</label>
                  <select
                    class="card-input__input -select"
                    style="margin-bottom: 20px"
                    v-model="campers[camperIndex + 1].tShirtSize"
                    required
                  >
                    <option disabled selected value="">Size</option>
                    <option value="YS" class="option">Youth Small</option>
                    <option value="YM" class="option">Youth Medium</option>
                    <option value="YL" class="option">Youth Large</option>
                    <option value="AS" class="option">Adult Small</option>
                    <option value="AM" class="option">Adult Medium</option>
                    <option value="AL" class="option">Adult Large</option>
                    <option value="AXL" class="option">Adult XLarge</option>
                    <option value="AXXL" class="option">Adult XXLarge</option>
                  </select>
                </div>
                <!--Start of Custom Forms-->
                <li
                  style="list-style-type: none"
                  v-for="(count, index) in campers[camperIndex + 1]
                    .customFields"
                  :key="index"
                >
                  <CustomField
                    :presetField="campers[camperIndex + 1].customFields[index]"
                    :number="camperIndex + 1"
                    :index="
                      index +
                      (camperIndex + 1) *
                        campers[camperIndex + 1].customFields.length
                    "
                    @changed="
                      updateFieldValue(camperIndex + 1, index, $event.field)
                    "
                  ></CustomField>
                </li>
                <!--End of Custom Forms-->
                <div
                  class="p-3 border-b border-gray-100"
                  v-if="!this.hideRecruitAds"
                >
                  <div class="flex items-center justify-between">
                    <div class="flex items-center">
                      <input
                        class="form-check-input h-4 w-4 rounded border-gray-300 focus:ring-2 focus:ring-indigo-500/50 transition-all duration-200 cursor-pointer"
                        type="checkbox"
                        :id="`recruitPurchased-${camperIndex + 1}`"
                        v-model="campers[camperIndex + 1].recruitPurchased"
                      />
                      <span
                        class="text-gray-700 ml-3 font-normal cursor-pointer"
                        @click="
                          campers[camperIndex + 1].recruitPurchased =
                            !campers[camperIndex + 1].recruitPurchased
                        "
                        >Athlete Profile</span
                      >
                    </div>
                    <span
                      class="text-gray-800 font-medium"
                      style="color: v-bind('primaryColor')"
                      >$15.00<span class="text-sm text-gray-500 font-normal"
                        >/month</span
                      ></span
                    >
                  </div>
                </div>
                <!--Start of Custom Add Ons-->
                <div
                  v-if="campers[camperIndex + 1].customAddOns.length > 0"
                  class="bg-white rounded-md shadow-sm p-4 my-4"
                >
                  <h5
                    class="text-center font-semibold text-lg mb-4 text-gray-700"
                  >
                    Additional Items
                  </h5>

                  <div class="space-y-2">
                    <div
                      v-for="(addon, index) in campers[camperIndex + 1]
                        .customAddOns"
                      :key="index"
                      class="bg-gray-50 rounded-md p-3 transition-all duration-200 hover:shadow-sm"
                    >
                      <div class="flex items-start gap-3">
                        <div class="pt-0.5">
                          <input
                            type="checkbox"
                            v-model="
                              campers[camperIndex + 1].customAddOns[index]
                                .isPurchased
                            "
                            class="h-4 w-4 rounded border-gray-300 focus:ring-1 cursor-pointer"
                            :style="{
                              'accent-color': primaryColor,
                              '--tw-ring-color': primaryColor + '80',
                            }"
                          />
                        </div>

                        <div class="flex-grow">
                          <h5 class="font-medium text-gray-800 text-sm">
                            {{ addon.addOnName }}
                          </h5>
                          <p class="text-gray-400 text-xs mt-0.5">
                            Add this to complete your registration
                          </p>
                        </div>

                        <div
                          class="text-lg font-medium"
                          :style="{ color: '#000000' }"
                        >
                          ${{ addon.addOnPrice }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 text-center text-xs text-gray-400">
                    Select optional items to enhance your camp experience
                  </div>
                </div>

                <!--End of Custom Add Ons-->

                <i
                  class="fa-solid fa-trash removeDay"
                  @click="removeAdditionalCamper(camperIndex + 1)"
                ></i>
                <div
                  v-if="getAddOnLength != 0"
                  class="list-group-item"
                  style="margin-left: 12px"
                ></div>
              </div>
            </li>
          </div>
          <!--end of extra registrants-->
          <div v-if="checkAddRegistrantButton" class="flex justify-center">
            <button
              class="flex items-center justify-center gap-2 text-white py-1 px-3 font-small transition-colors duration-200 custom-button mb-2"
              @click="addAdditionalCamper"
              :style="{
                marginTop: '10px',
                color: 'white',
              }"
            >
              Add Registrant - ${{ getAdditionalCamperPrice }}
            </button>
          </div>
          <br v-show="!this.emergencyBool" />
          <h3 v-show="!this.emergencyBool">Emergency Contact Information</h3>
          <div v-show="!this.emergencyBool" style="margin-top: 15px">
            <div class="row">
              <div class="card-input col">
                <label class="card-input__label">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  class="card-input__input"
                  v-model="emergencyContactInfo.firstName"
                />
              </div>
              <div class="card-input col">
                <label class="card-input__label">Last Name</label>
                <input
                  type="text"
                  id="name"
                  class="card-input__input"
                  v-model="emergencyContactInfo.lastName"
                />
              </div>
            </div>
            <div class="card-input">
              <label class="card-input__label">Phone Number</label>
              <input
                type="text"
                id="phoneNumber"
                class="card-input__input"
                v-model="emergencyContactInfo.phoneNumber"
              />
            </div>
            <div class="card-input">
              <label class="card-input__label">Email</label>
              <input
                type="email"
                id="email"
                class="card-input__input"
                v-model="emergencyContactInfo.email"
              />
            </div>
            <div class="card-input">
              <label class="card-input__label">Address</label>
              <input
                type="text"
                id="address"
                class="card-input__input"
                v-model="emergencyContactInfo.address"
              />
            </div>
            <div class="card-input">
              <label class="card-input__label">City</label>
              <input
                type="text"
                id="address"
                class="card-input__input"
                v-model="emergencyContactInfo.city"
              />
            </div>

            <div class="card-form__row">
              <div class="card-form__col">
                <div class="card-form__group">
                  <label for="cardMonth" class="card-input__label">State</label>
                  <select
                    class="card-input__input -select"
                    id="cardMonth"
                    v-model="emergencyContactInfo.state"
                  >
                    <option value="" disabled selected>State</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>
              </div>
              <div class="card-form__col">
                <div class="card-input">
                  <label for="cardCvv">Zip Code</label>
                  <input
                    type="text"
                    class="card-input__input"
                    v-model="emergencyContactInfo.zipCode"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="!freeRegistration">
            <hr />

            <h5 class="text-center">Pay With</h5>
            <div class="row mt-3">
              <div class="col-md-6 col-sm-6">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="paypal"
                    v-model="this.paymentType"
                  />
                  <label class="form-check-label" for="inlineRadio1"
                    ><a title="PayPal"
                      ><img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/2560px-PayPal.svg.png"
                        alt="PayPal"
                        style="max-height: 30px; max-width: 100px"
                      /> </a
                  ></label>
                </div>

                <br />
                <br />
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio3"
                    value="venmo"
                    v-model="this.paymentType"
                  />
                  <label class="form-check-label" for="inlineRadio3"
                    ><a title="Venmo"
                      ><img
                        src="https://images.ctfassets.net/gkyt4bl1j2fs/273APNSE63eFeQGVaNokaJ/da5948b50660aa0a99b02ea2e6990e2f/Blue.png?w=424&h=84&q=50&fm=webp&bg=transparent"
                        alt="venmo"
                        style="max-height: 30px; max-width: 100px"
                      /> </a
                  ></label>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 mt-5">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio4"
                    value="creditcard"
                    v-model="this.paymentType"
                  />
                  <label class="form-check-label" for="inlineRadio4"
                    ><h5>
                      <i
                        class="fa-solid fa-credit-card fa-lg"
                        style="color: #0d0d0d"
                      ></i>
                      Credit/Debit
                    </h5></label
                  >
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>

          <!-- Do not change the v-ifs here. There is a strange edge case @Marcus. Don't mess with it. -->
          <input
            v-if="this.camp.campPrice > 0"
            class="form-check-input me-2"
            type="checkbox"
            value=""
            id="form6Example8"
            v-model="this.emergencyBool"
          />
          <label
            v-if="this.camp.campPrice > 0"
            class="form-check-label"
            for="form6Example8"
          >
            Emergency Contact is Billing Info
          </label>
          <br />
          <br />
          <div class="row">
            <button
              class="w-full flex items-center justify-center gap-2 text-white py-3 px-6 font-medium transition-colors duration-200 custom-button !text-xl"
              @click="submitCamperInfo()"
            >
              Next
            </button>
          </div>
          <div class="row mt-3">
            <button
              class="w-full flex items-center justify-center gap-2 text-white py-3 px-6 font-medium transition-colors duration-200 custom-button !text-xl"
              @click="back"
            >
              <i class="fa-solid fa-arrow-left"></i>
              Back
            </button>
          </div>
        </template>
      </div>
    </div>
    <!-- Athlete Profile Modal -->
    <AthleteProfileModal
      v-if="showAthleteProfileModal"
      :show="showAthleteProfileModal"
      :primaryColor="primaryColor"
      @close="showAthleteProfileModal = false"
    />
  </div>
</template>
<script>
import swal from 'sweetalert'
// import axios from "axios";
import CustomField from '../SubComponents/CustomField.vue'
import AthleteProfileModal from '../SubComponents/RecruitInfoPopUp.vue'

import numeral from 'numeral'

export default {
  components: {
    CustomField,
    AthleteProfileModal,
  },
  props: {
    camp: Object,
    isMobile: Boolean,
    presetCampers: Array,
    presetEmergencyContactInfo: Object,
    presetEmergencyBool: Boolean,
    presetPaymentType: String,
    sessionInfo: Object,
    hideRecruitAds: Boolean,
  },
  data() {
    return {
      campers: [],
      emergencyBool: this.presetEmergencyBool,
      emergencyContactInfo: this.presetEmergencyContactInfo,
      requiredFilesShown: false,
      addingAdditionalCampers: false,
      paymentType: this.presetPaymentType,
      showAthleteProfileModal: false,
    }
  },
  methods: {
    back() {
      const currentRoute = this.$route.path
      const newRoute = currentRoute.replace('campcheckout', 'viewpayment')
      this.$router.push(newRoute)
    },
    getImage() {
      if (this.camp.campLogo == null || this.camp.campLogo == '')
        return '/landscape.svg'
      else return this.camp.campLogo
    },
    async proceed() {},
    removeAdditionalCamper(removalIndex) {
      this.campers.splice(removalIndex, 1)
    },
    validateCamperInfo() {
      for (const camper of this.campers) {
        if (!camper.firstName) {
          swal('Error', 'Please fill out first name.', 'error')
          return false
        }
        if (!camper.lastName) {
          swal('Error', 'Please fill out last name.', 'error')
          return false
        }
        if (this.camp.tShirtsProvided) {
          if (!camper.tShirtSize) {
            swal('Error', 'Please fill out T-Shirt size.', 'error')
            return false
          }
        }
        for (const field of camper.customFields) {
          if (!field.fieldValue) {
            swal('Error', `Please fill out ${field.fieldName}.`, 'error')
            return false
          }
        }
      }

      //If the camp is free, we need to validate the emergency contact info since no billing info is needed
      if (this.camp.campPrice === 0) {
        if (!this.emergencyContactInfo.firstName) {
          swal(
            'Error',
            'Please fill out emergency contact first name.',
            'error',
          )
          return false
        }
        if (!this.emergencyContactInfo.lastName) {
          swal('Error', 'Please fill out emergency contact last name.', 'error')
          return false
        }
        if (!this.emergencyContactInfo.phoneNumber) {
          swal(
            'Error',
            'Please fill out emergency contact phone number.',
            'error',
          )
          return false
        }
        if (!this.emergencyContactInfo.email) {
          swal('Error', 'Please fill out emergency contact email.', 'error')
          return false
        }
        if (!this.emergencyContactInfo.address) {
          swal('Error', 'Please fill out emergency contact address.', 'error')
          return false
        }
        if (!this.emergencyContactInfo.city) {
          swal('Error', 'Please fill out emergency contact city.', 'error')
          return false
        }
        if (!this.emergencyContactInfo.state) {
          swal('Error', 'Please fill out emergency contact state.', 'error')
          return false
        }
        if (!this.emergencyContactInfo.zipCode) {
          swal('Error', 'Please fill out emergency contact zip code.', 'error')
          return false
        }
      }
      return true
    },
    async submitCamperInfo() {
      const validated = this.validateCamperInfo()
      if (!validated) {
        return
      }
      if (!this.emergencyBool) {
        this.campers.forEach(camper => {
          camper.emergencyContactInfo = this.emergencyContactInfo
        })
      }
      swal({
        title: 'Agree and Accept Liability',
        text: this.getCampWaiver,
        icon: 'warning',
        buttons: ['Cancel registration', 'I understand and accept liability'],
        dangerMode: true,
      }).then(isConfirm => {
        if (isConfirm) {
          this.$emit(
            'proceed',
            this.campers,
            this.emergencyBool,
            this.paymentType,
          )
        } else {
          swal('Cancelled', 'Registration cancelled.', 'error')
        }
      })
    },
    createCamperArray() {
      if (this.presetCampers != null) {
        this.campers = this.presetCampers
        return
      }
      console.log('here')
      let campCustomFields = this.camp.customFields.map(field => ({
        ...field,
        fieldValue: null, // Default value for fieldValue
      }))
      let campAddOns = this.camp.customAddOns.map(addOn => ({
        ...addOn,
        isPurchased: false, // Default value for isPurchased
      }))
      let camper = {
        firstName: null,
        lastName: null,
        address: null,
        tShirtSize: null,
        email: null,
        phoneNumber: null,
        customFields: campCustomFields,
        customAddOns: campAddOns,
        recruitPurchased: false,
      }
      this.campers = []
      this.campers.push(camper)
    },
    addAdditionalCamper() {
      let campCustomFields = this.camp.customFields.map(field => ({
        ...field,
        fieldValue: null, // Default value for fieldValue
      }))
      let campAddOns = this.camp.customAddOns.map(addOn => ({
        ...addOn,
        isPurchased: false, // Default value for isPurchased
      }))
      let camper = {
        firstName: null,
        lastName: null,
        address: null,
        tShirtSize: null,
        email: null,
        phoneNumber: null,
        customFields: campCustomFields,
        customAddOns: campAddOns,
      }
      console.log(camper)
      this.campers.push(camper)
    },
    updateFieldValue(camperIndex, fieldIndex, field) {
      this.campers[camperIndex].customFields[fieldIndex] = field
    },
    athleteProfileInfo(event) {
      // Modified to show the modal instead of navigating
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.showAthleteProfileModal = true
    },
  },

  created() {
    this.createCamperArray()
  },

  computed: {
    checkAddRegistrantButton() {
      return this.camp.sessionSupported ? false : true
    },
    freeRegistration() {
      let freeRegistration = this.camp.campPrice === 0
      if (freeRegistration) {
        for (const camper of this.campers) {
          if (camper.recruitPurchased) {
            freeRegistration = false
            break
          }
          for (const addOn of camper.customAddOns) {
            if (addOn.isPurchased) {
              freeRegistration = false
              break
            }
          }
        }
      }
      return freeRegistration
    },
    getCampWaiver() {
      let waiver =
        'Summer Athletes accepts no liability for any physical injury, and all refunds are handled by the organizer. Additionally, by accepting you are consenting to receive important message updates about the event.'
      if (this.camp.requireWaiver) {
        waiver =
          'Summer Athletes and the organizer accept no liability for any physical injury, and all refunds are handled by the organizer. Additionally, by accepting you are consenting to receive important message updates about the event.'
        if (this.camp.customWaiver != null) {
          if (this.camp.customWaiver != '')
            waiver =
              this.camp.customWaiver +
              '\n\nIn addition to the waiver above, Summer Athletes accepts no liability for any physical injury. All refunds are handled by the organizer. Additionally, by accepting you are consenting to receive important message updates about the event.'
        }
      }
      return waiver
    },
    getAdditionalCamperPrice() {
      // Ensure camp and relevant data are available
      if (
        !this.camp ||
        !this.camp.multipleCamperPrices ||
        this.campers.length < 1
      ) {
        return 0 // Default to 0 if data is missing
      }

      // Determine the number of current campers
      const currentCampers = this.campers.length

      // Determine the price for the next camper
      if (currentCampers < this.camp.multipleCamperPrices.length) {
        // Use the next tier price for additional campers
        return this.camp.multipleCamperPrices[currentCampers - 1].camperPrice
      }

      // If no tier is available, return the last defined tier price
      return (
        this.camp.multipleCamperPrices[
          this.camp.multipleCamperPrices.length - 1
        ]?.camperPrice || this.camp.campPrice
      )
    },
    primaryColor() {
      return this.$route.params.primaryColor
        ? '#' + this.$route.params.primaryColor
        : '#363166'
    },
  },
  mounted() {},
}
</script>
<style scoped>
img.rounded-corners {
  border-radius: 10px;
}
.custom-button {
  border-radius: 8px !important;
  -webkit-border-radius: 8px !important;
  -moz-border-radius: 8px !important;
  background-color: v-bind('primaryColor') !important;
}
.custom-button:hover {
  filter: brightness(0.95) !important;
}
</style>

```
